import React, { Suspense, useEffect, useState } from 'react';
import { Box } from 'src/components/ui';
import FusionLoading from 'src/components/common/FusionLoading';
import useWarnBeforeUnload from 'src/hooks/useWarnIfUnsavedChanges';

const DesignerModule = React.lazy(() => import('designer_module/editor').catch(() => {
	// Fallback when designer module is not available
	return {
		default: ({ onClose }: { onClose: () => void }) => (
			<div style={{ 
				padding: '20px', 
				textAlign: 'center',
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
				height: '100vh',
				gap: '20px'
			}}>
				<h2>Design Editor Unavailable</h2>
				<p>The design editor module is currently not available. This could be due to:</p>
				<ul style={{ textAlign: 'left', maxWidth: '400px' }}>
					<li>The design editor service is not running</li>
					<li>Network connectivity issues</li>
					<li>Module federation configuration issues</li>
				</ul>
				<button 
					onClick={onClose}
					style={{
						padding: '10px 20px',
						backgroundColor: '#3182ce',
						color: 'white',
						border: 'none',
						borderRadius: '4px',
						cursor: 'pointer'
					}}
				>
					Close Editor
				</button>
			</div>
		)
	};
}));

interface IDesignProps {
	onClose: () => void;
	onSave: (updatedTemplate: any) => Promise<void>;
	onChange: (updatedTemplate: any) => void;
	template: any;
	fonts: any;
}

const Design = ({
	fonts,
	template,
	onSave,
	onClose,
	onChange,
}: IDesignProps) => {
	const [isLoading, setIsLoading] = useState(true);

	useWarnBeforeUnload(true);

	useEffect(() => {
		const currentPath = window.location.pathname;
		if (!currentPath.endsWith('/editing')) {
			window.history.replaceState({}, '', currentPath + '/editing');
		}

		return () => {
			let newPath = window.location.pathname.replace(/\/editing$/, '');
			newPath = newPath.replace(/\/design$/, '');
			window.history.replaceState({}, '', newPath);
		};
	}, []);

	return (
		<Box w="100%" h="100vh" bg="whitesmoke">
			{isLoading && <FusionLoading isLoading={isLoading} />}
			<Suspense>
				<Box visibility={isLoading ? 'hidden' : 'visible'}>
					<DesignerModule
						fonts={fonts}
						template={template}
						onSave={onSave}
						onClose={onClose}
						onChange={onChange}
						onLoad={() => setIsLoading(false)}
					/>
				</Box>
			</Suspense>
		</Box>
	);
};

export default Design;
